"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Button_1 = __importDefault(require("@material-ui/core/Button"));
var Grid_1 = __importDefault(require("@material-ui/core/Grid"));
var styles_1 = require("@material-ui/core/styles");
var Typography_1 = __importDefault(require("@material-ui/core/Typography"));
var package_1 = require("@pbl/pbl-react-web-components/lib/package");
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var constants_1 = __importDefault(require("../../../../config/constants"));
var actions_1 = require("../../../../redux/reducers/password/actions");
var styles_2 = __importDefault(require("../styles"));
var UpdateEmailConfirmForm = function (_a) {
    var oldEmail = _a.oldEmail, newEmail = _a.newEmail, validationSchema = _a.validationSchema, onConfirm = _a.onConfirm, onCancel = _a.onCancel;
    var theme = (0, styles_1.useTheme)();
    var classes = (0, styles_2.default)(theme)();
    var dispatch = (0, react_redux_1.useDispatch)();
    var _b = (0, react_redux_1.useSelector)(function (state) { return state.passwordChange; }), checking = _b.checking, currentPasswordValid = _b.currentPasswordValid;
    var _c = (0, react_1.useState)(''), currentPassword = _c[0], setCurrentPassword = _c[1];
    var currentPasswordField = {
        type: 'password',
        key: 'currentPassword',
        label: 'Current Password',
        get placeholder() {
            return this.label;
        },
        value: currentPassword,
        disabled: checking,
        isRequired: true,
        showPassword: true,
        secureTextEntry: true,
        get fieldValue() {
            return this.value;
        },
        validationSchema: validationSchema
    };
    var onCheckPassword = function () {
        if (currentPassword) {
            dispatch((0, actions_1.checkPassword)(currentPassword));
        }
    };
    return (react_1.default.createElement(Grid_1.default, { container: true, spacing: 3, direction: "column" },
        react_1.default.createElement(Grid_1.default, { item: true },
            react_1.default.createElement(Typography_1.default, { variant: "body1", style: { textAlign: 'center' } }, "Are you sure you want to change your current email?"),
            react_1.default.createElement(Typography_1.default, { variant: "subtitle1", style: { textAlign: 'center' } }, oldEmail),
            react_1.default.createElement(Typography_1.default, { variant: "body1", style: { textAlign: 'center' } }, "to"),
            react_1.default.createElement(Typography_1.default, { variant: "subtitle1", style: { textAlign: 'center' } }, newEmail)),
        react_1.default.createElement(Grid_1.default, { item: true },
            react_1.default.createElement(Typography_1.default, { variant: "body1", style: { textAlign: 'center', marginBottom: theme.spacing(2) } }, "Once changed, use your new email to sign in to your account and to receive email notifications and updates from us.")),
        react_1.default.createElement(Grid_1.default, { item: true },
            react_1.default.createElement(package_1.FieldRenderer, { field: currentPasswordField, onChange: setCurrentPassword, className: classes.field, theme: theme, inputProps: {
                    autoComplete: "password",
                    error: currentPasswordValid !== null && !currentPasswordValid,
                    helperText: currentPasswordValid !== null && !currentPasswordValid ? 'Invalid Password' : null,
                    fullWidth: true,
                    onBlur: onCheckPassword,
                    variant: constants_1.default.FIELDS_VARIANT
                } })),
        react_1.default.createElement(Grid_1.default, { item: true, style: {
                marginTop: theme.spacing(3),
                marginBottom: theme.spacing(4)
            } },
            react_1.default.createElement(Grid_1.default, { container: true, justifyContent: "center", spacing: 2 },
                react_1.default.createElement(Grid_1.default, { item: true },
                    react_1.default.createElement(Button_1.default, { size: "large", variant: "outlined", color: "primary", "aria-label": "No", onClick: onCancel }, "No")),
                react_1.default.createElement(Grid_1.default, { item: true },
                    react_1.default.createElement(Button_1.default, { size: "large", variant: "outlined", color: "primary", "aria-label": "Yes, Change Email", onClick: onConfirm(currentPassword), disabled: !currentPasswordValid }, "Yes Change Email"))))));
};
exports.default = UpdateEmailConfirmForm;
//# sourceMappingURL=UpdateEmailConfirmForm.js.map